<div class="form-row">
  <div class="form-item" *ngIf="to?.addIcons">
    <div *ngIf="to?.required && !to.repeatAddAnother" class="required">
      This field is required
    </div>
    <div class="text-center" *ngIf="!to?.options?.length">
      No matching {{ to?.label }} found
    </div>
    <!-- Check if to?.icon exists -->
    <ng-container *ngIf="to?.addIcons">
      <div class="box-container" *ngFor="let item of to.options">
        <div class="box" (click)="handleOptionSelect(item)">
    
          <div *ngIf="item?.icon?.startsWith('http'); else svgTemplate">
            <img [src]="item?.icon" alt="icon name" class="item-icon">    
          </div>

    
          <ng-template #svgTemplate>
            <span class="item-icon" [innerHTML]="item?.icon | safe: 'html'"></span>
          </ng-template>
          <span class="item-label" *ngIf="!linkLoading || selectedItem.value !== item.value">{{ item?.label }}</span>
          <span *ngIf="linkLoading && selectedItem.value === item.value" class="spinner"></span>
        </div>
      </div>
    </ng-container>
  </div>
  
  <div>
    <label class="font-normal font-medium text-[16px] font-inter text-gray-200 text-base"> {{to?.label}} </label>
    <ng-container *ngIf="!to?.addIcons">
      <div
        [ngClass]="
          item?.value === getValue() || isSelectedOption(item.value)
            ? 'input-container selected'
            : 'input-container '
        "
        *ngFor="let item of to.options"
        (click)="handleOptionSelect(item)"
      >
        <span
          class="checkbox"
          [ngClass]="isSelectedOption(item.value) ? 'checked' : ''"
          *ngIf="isMultipleSelect"
        ></span>
        <div class="label-container">
          <span class="input-text" *ngIf="item?.label && (!linkLoading || selectedItem.value !== item.value)">
            {{ item?.label }}
          </span>
          <span *ngIf="linkLoading && selectedItem.value === item.value" class="spinner"></span>
          <div>
            <img
              [style.display]="
                !isMultipleSelect && isSelectedOption(item.value)
                  ? 'block'
                  : 'none'
              "
              src="../../assets/icon/check_24px.png"
            />

            <img
              src="../../assets/icon/info_24px.svg"
              class="tooltip"
              *ngIf="item?.tooltip"
              [tooltip]="item?.tooltip"
              (click)="handleTooltipClick($event)"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
